import { TemplateFormEditor } from "src/cases/templates/common/TemplateFormEditor";
import {
  createFormFieldKeyValidators,
  createFormFieldNameValidators,
  createFormFieldOptionValidators,
} from "src/cases/templates/validators";

export const CaseActionFormEditor: React.FC<{
  actionIndex: number;
}> = ({ actionIndex }) => {
  return (
    <TemplateFormEditor
      fieldKeyValidators={(itemIndex) =>
        createFormFieldKeyValidators("action", itemIndex)
      }
      fieldNameValidators={createFormFieldNameValidators()}
      fieldOptionValidators={(itemIndex, fieldIndex) =>
        createFormFieldOptionValidators("action", itemIndex, fieldIndex)
      }
      itemIndex={actionIndex}
      itemType="action"
    />
  );
};
